import { Typography } from '@material-ui/core'
import React from 'react'

function PostPageStart() {
    return (
        <div>
            <img src="https://images.typeform.com/images/mEHKkenafW4n/image/default" alt="img"/>
            <Typography component="h1" variant="div" color="secondary">Submit Your Guest Post</Typography>
        </div>
    )
}

export default PostPageStart
